<template>
  <div class="assign-items">
    <div class="col-md-12 row align-items-end no-padding no-margin subheader-assign d-flex align-items-center">
      <div class="col-8 no-padding">
        {{
          $t('message.assignofitems', {
            selected_count: this.input.length,
            items_count: this.items.length,
          })
        }}
      </div>
      <div class="col-4 no-padding text-right">
        <button
          v-if="!disabled"
          class="btn btn-sm"
          @click="onSelectedAll">
          {{ $t('button.selectall') }}
        </button>
      </div>
    </div>
    <div class="container-items">
      <div
        v-for="(item, index) in mapItems"
        :class="['col-md-12 row align-items-center no-margin item', { active: item.active }, { disabled }]"
        :key="index"
        @click="toggle(item)"
      >
        <div :class="`col-${colName}`">
          {{ item.text }}
        </div>
        <div :class="`col-${colValue} text-right`">
          {{ item.label }}
          <i class="fas fa-check-circle"/>
          <i class="far fa-circle"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Array,
    items: Array,
    primaryId: [String, Number],
    primaryName: String,
    replace: Boolean,
    colName: {
      type: Number,
      default: 9,
    },
    colValue: {
      type: Number,
      default: 3,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      input: [],
      selectedAll: false,
    }
  },

  computed: {
    mapItems () {
      const { primaryId, primaryName } = this
      return this.items.map((item) => {
        const active = this.input.includes(item.value)
        const label = (() => {
          if ((active && item.primaryId !== primaryId) || (active && !primaryId) && this.replace) {
            return primaryName
          }
          return item.primaryName
        })()
        return { ...item, active, label }
      })
    },
  },

  watch: {
    input () {
      this.$emit('input', this.input)
    },
    value () {
      this.input = this.value
    },
  },

  created () {
    this.input = this.value
  },

  methods: {
    toggle ({ value }) {
      if (this.disabled) {
        return
      }

      if (!this.input.includes(value)) {
        this.addItem(value)
      } else {
        this.removeItem(value)
      }
    },
    addItem (value) {
      this.input.push(value)
    },
    removeItem (value) {
      const index = this.input.findIndex((item) => item === value)
      this.input.splice(index, 1)
    },
    onSelectedAll () {
      if (this.input.length === this.items.length) {
        this.input = []
      } else {
        this.input = this.items.reduce((acc, cur) => {
          return acc.push(cur.value) && acc
        }, [])
      }
    },
  },
}
</script>

<style scoped>
.container-items {
  max-height: 351px;
  overflow-y: auto;
}

.container-items::-webkit-scrollbar {
  width: 8px;
}

.container-items::-webkit-scrollbar-track {
  background-color: #e6e6e6;
  border-radius: 4px;
}

.container-items::-webkit-scrollbar-thumb {
  background-color: #999999;
  border-radius: 4px;
}

.item {
  padding: 6px 0 6px 0;
}

.item.disabled {
  cursor: default;
  background: rgba(216, 226, 231, .15);
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseAssignItems.vue